var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { Component, ComponentFactoryResolver, EventEmitter, HostListener, Input, OnInit, Output, Type, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { alert, custom } from 'devextreme/ui/dialog';
import { NicaInfoAnagraficaAziendaComponent } from '../anagrafiche/nica-info-anagrafica-azienda/nica-info-anagrafica-azienda.component';
import { NicaDynamicContentComponent } from '../nica-dynamic-content/nica-dynamic-content.component';
import { NicaFormComponent } from '../nica-form/nica-form.component';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { NicaMapsComponent } from '../../widgets/nica-maps/nica-maps.component';
import notify from 'devextreme/ui/notify';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { NewNicaFormComponent } from '../nica-form/new-nica-form.component';
import { ModelliStampaService } from '../../services/modelli-stampa.service';
var NicaMaster = /** @class */ (function () {
    function NicaMaster(userComponentService, templateService, _overlaySideFormService, _overlaySidePanelService, formTemplateService, _componentFactoryResolver, activatedroute, router, menuService, rentriService, anagraficaService, modelliStampaService, loader) {
        this.userComponentService = userComponentService;
        this.templateService = templateService;
        this._overlaySideFormService = _overlaySideFormService;
        this._overlaySidePanelService = _overlaySidePanelService;
        this.formTemplateService = formTemplateService;
        this._componentFactoryResolver = _componentFactoryResolver;
        this.activatedroute = activatedroute;
        this.router = router;
        this.menuService = menuService;
        this.rentriService = rentriService;
        this.anagraficaService = anagraficaService;
        this.modelliStampaService = modelliStampaService;
        this.loader = loader;
        this.onAllEvent = new EventEmitter();
        this.showFormEdit = false;
        this.filterID = [];
        this.rowData = [];
        this.thisVisible = false;
        this.serviceButtonsArray = [];
        this.buttonToolbarUp = [];
        this.buttonToolbarBottom = [];
        this.nCol = 2;
        this.isOpen = false;
        this.InAttesaOpen = false;
        this.anagraficaDati = [];
        this.queryFilter = [];
        this.showToolBar = false;
        this.flag = false;
        this.filterGrid = '';
        this.cronNavigation = [];
        this.idBreadcrumbGroup = null;
        this.breadcrumbNavigation = [];
        this.showToolbarC = true;
        this.backgroundToolbar = '#337ab7';
        this.textColorToolbar = '#fff';
        this.cssClass = '';
        this.bakgroundToolbar = "#337ab7"; //'#045072'
        this.evalIII = function (dataCheck, cond, value) {
            var returned;
            switch (cond) {
                case '==':
                    if (dataCheck == value) {
                        returned = true;
                    }
                    else {
                        returned = false;
                    }
                    ;
                    break;
                case '>':
                    if (dataCheck > value) {
                        returned = true;
                    }
                    else {
                        returned = false;
                    }
                    break;
                case '<':
                    if (dataCheck < value) {
                        returned = true;
                    }
                    else {
                        returned = false;
                    }
                    break;
                case '!=':
                    if (dataCheck != value) {
                        returned = true;
                    }
                    else {
                        returned = false;
                    }
                    break;
                default:
                    returned = false;
                    break;
            }
            return returned;
        };
    }
    /*
    ngAfterContentChecked(): void {
  
    }
    ngAfterContentInit(): void {
      throw new Error('Method not implemented.');
    }
    */
    NicaMaster.prototype.handleKeyDown = function (event) {
        ////console.log(event)
        if (event.code == 'F1') {
            event.preventDefault();
            var data = [];
            this.refreshPage(data, 'Elenco', this.SubjectCall, 'grid');
            event.stopImmediatePropagation();
        }
        if (event.code == 'F4') {
            event.preventDefault();
            var data = [];
            this.refreshPage(data, 'Elenco', this.SubjectCall, 'form');
            event.stopImmediatePropagation();
        }
        if (event.code == 'F10') {
            this.formAnagrafica.onFormSubmit();
            event.preventDefault();
            event.stopImmediatePropagation();
        }
        /* if (event.code == 'Escape') {
          event.preventDefault();
          event.stopImmediatePropagation();
          const prevNav = this.userComponentService.getPrevItemComponentNavigation(this.SubjectCall, this.currentTabId);
    
    
          const navigationParams = prevNav.params
          this.router.navigate(['/'], {
            skipLocationChange: true,
            replaceUrl: true
          }).then(() => {
            // Forzo a naviagare verso questa url per aggiornare i dati.
    
            //sono costretto a ricaricare in maniera forzata il componente in attesa di idee
            let navigationExtras: NavigationExtras = {
              queryParams: navigationParams, skipLocationChange: true,
              replaceUrl: true
            };
            this.router.navigate([prevNav.cRouter], navigationExtras);
    
    
            //this.userComponentService.removeItemComponentNavigation(this.SubjectCall, this.currentTabId)
          })
        } */
        /* if (event.code == 'End') {
          let e = {
            name: 'return'
          }
    
          this.formEvent(e)
        } */
    };
    NicaMaster.prototype.ngAfterViewInit = function () {
        /*  if (this.buttonToolbarBottom.length <= 0 && this.buttonToolbarUp.length <= 0) {
           this.showToolBar = false
         }
      */
    };
    NicaMaster.prototype.ngOnInit = function () {
        var _this = this;
        if (typeof this.itemData != undefined) {
        }
        else {
            ////console.log('url',this.router.url)
            this.activatedroute.queryParams
                .subscribe(function (params) {
                _this.currentTabId = params.currentTabId,
                    _this.currentTabName = params.currentTabName;
                _this.showToolBar = false; //Per ora ...
                _this.setGlobalVariableFromParams(params);
            });
        }
    };
    NicaMaster.prototype.setGlobalVariable = function (itemData) {
        /*
          id: id,
          api: api,
          service: service,
          masterKey: 'id',
          filter: filter,
          descEvent: descEvent,
          templateView: template,
          titoloDaPortare: titoloDaPortare,
          data: dataToSend,
          prevUrl: this.previusUrl,
          currentTabId: this.currentTabId,
          currentTabName: this.currentTabName,
          componentName: componentName
    
        
        */
        this.apiset = itemData[0].api;
        this.id = itemData[0].id;
        this.queryString = itemData[0].queryString;
        this.rowData = itemData[0].dati;
        this.template = itemData[0].template;
        this.masterKey = itemData[0].masterKey;
        this.type = itemData[0].tipo;
        this.SubjectCall = itemData[0].SubjectCall;
        this.InviaA = itemData[0].inviaA;
        this.toolbarComponentFilter = itemData[0].toolbarComponent;
        this.filterID = JSON.parse(itemData[0].filter);
        this.cssClass = itemData[0].cssClass;
        //this.prevUrl= this.previusUrl,
        this.currentTabId = itemData[0].currentTabId;
        this.currentTabName = itemData[0].currentTabName;
        // this.componentName = itemData[0].componentName
    };
    NicaMaster.prototype.impostaDatiForm = function (routerParam, anagraficaFilter) {
        //Costrusco i dati costanti da inviare alla form.
        var _this = this;
        var data;
        if (routerParam.filter) {
            data = JSON.parse(routerParam.filter);
            ////console.log('routerParamData', data)
            if (anagraficaFilter[0]['configuration']['idTabRif']) {
                var arrayIdRif = anagraficaFilter[0]['configuration']['idTabRif'];
                arrayIdRif.forEach(function (idTab) {
                    if (typeof data[idTab['value']] != 'undefined') {
                        _this.rowData[idTab['key']] = data[idTab['value']];
                    }
                });
            }
            //console.log('rowData', this.rowData)
        }
    };
    NicaMaster.prototype.impostaFiltroForm = function (routerParam, filterEditor) {
        if (filterEditor.includes('$')) {
            /*if (this.id != '' && typeof this.id != 'undefined') {
              this.queryString = filterEditor.replace('$', this.id)
            } */
            this.queryString = filterEditor;
            var espressioneVariabile = /\$\w+/mg;
            // Verifica se nella stringa sono presenti altre variabili oltre a $id
            if (espressioneVariabile.test(filterEditor)) {
                //Se sta in ro
                var rowData = this.rowData;
                for (var x in rowData) {
                    if (typeof rowData[x] != 'undefined') {
                        if (rowData[x]) {
                            this.queryString = this.queryString.replace("$" + x, rowData[x]);
                        }
                    }
                }
                var filterID = this.filterID;
                for (var xx in filterID) {
                    if (typeof filterID[xx] != 'undefined') {
                        if (filterID[xx]) {
                            this.queryString = this.queryString.replace("$" + xx, filterID[xx]);
                        }
                    }
                }
            }
            else {
                var espressioneRegolare = /\$/;
                var nuovaStringa = filterEditor.replace(espressioneRegolare, this.id);
                this.queryString = nuovaStringa;
            }
        }
    };
    /** Imposta Titolo Griglia */
    NicaMaster.prototype.impostaTitoloGriglia = function (routerParam, anagraficaFilter) {
        var _this = this;
        var descEvent = routerParam.descEvent ? routerParam.descEvent : '';
        var keysTitleDaPortare = [];
        if (anagraficaFilter[0]['configuration']['campoTitle']) {
            keysTitleDaPortare = anagraficaFilter[0]['configuration']['campoTitle'];
        }
        var titleGriglia = anagraficaFilter[0]['configuration']['titleGriglia'];
        keysTitleDaPortare.forEach(function (keyTitleDaPortare) {
            if (_this.filterID[keyTitleDaPortare]) {
                var data = _this.filterID[keyTitleDaPortare];
                ;
                var dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
                var isMatch = dateType.test(data);
                if (isMatch) {
                    var date = new Date(data);
                    var month = date.getMonth();
                    month = month + 1;
                    var day = date.getDate().toString().padStart(2, '0');
                    data = day + '-' + month + '-' + date.getFullYear();
                }
                if (titleGriglia.includes(keyTitleDaPortare)) {
                    titleGriglia = titleGriglia.replace(keyTitleDaPortare, data);
                }
                //titleGriglia = titleGriglia.replace(keyTitleDaPortare, data)
            }
        });
        this.titleDynamic = titleGriglia;
        if (this.template == 'dynamicGrid') {
            this.setVariableDynamicGrid();
            //this.SetToolbarButtons();
        }
        this.filterID['isEdit'] = false;
        /*******************************************************/
    };
    /** Imposta Titolo Form */
    NicaMaster.prototype.impostaTitoloForm = function (anagraficaFilter) {
        var _this = this;
        //let descEvent = routerParam.descEvent ? routerParam.descEvent : ''
        var keysTitleDaPortare = anagraficaFilter[0]['configuration']['campoTitle'] ? anagraficaFilter[0]['configuration']['campoTitle'] : [];
        var titleDaPortare = '';
        var titleForm = anagraficaFilter[0]['configuration']['titleForm'];
        keysTitleDaPortare.forEach(function (keyTitleDaPortare) {
            if (_this.filterID[keyTitleDaPortare]) {
                var data = _this.filterID[keyTitleDaPortare];
                ;
                var dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
                var isMatch = dateType.test(data);
                if (isMatch) {
                    var date = new Date(data);
                    var month = date.getMonth();
                    month = month + 1;
                    var day = date.getDate().toString().padStart(2, '0');
                    data = day + '-' + month + '-' + date.getFullYear();
                }
                titleForm = titleForm.replace(keyTitleDaPortare, data);
            }
            else {
                titleForm = titleForm.replace(keyTitleDaPortare, '');
            }
        });
        this.titleDynamic = titleForm;
        if (typeof this.id == 'undefined' || this.id == '') {
            ////console.log('SetToolbarButtons', this.serviceButtonsArray)
            //this.SetToolbarButtons()
        }
    };
    /** Genera il filtro QueryString per la Griglia */
    NicaMaster.prototype.impostaFiltroGriglia = function (routerParam, anagraficaFilter) {
        /* if (this.queryString != '') {
    
          let queryString = this.queryString;
    
          // Crea un'espressione regolare per cercare "$filter=(...)"
          let regexFilter = /\$filter=\([^)]*\)/;
    
          // Esegui la ricerca nella stringa
          let matchFilter = queryString.match(regexFilter);
    
          // Verifica se c'è una corrispondenza
          if (matchFilter) {
    
            let parteSenzaFilter = matchFilter[0].replace(/\$filter=/, '');
            // Oppure, se vuoi rimuovere solo la parte ?$filter=
            //console.log("Trovato:", parteSenzaFilter);
    
            this.filterOdata = parteSenzaFilter;
    
            queryString = queryString.replace(matchFilter[0],'');
            this.queryString = queryString
          }
    
          if (this.queryString.includes('$')) {
            for (let x in this.dataJson) {
              if (queryString.includes(x)) {
                let regex = new RegExp('\\$' + x + '\\b', 'g');
                queryString = queryString.replace(regex, this.dataJson[x]);
                //queryString = queryString.replace('$' + x, this.dataJson[x]);
    
              }
            }
            this.queryString = queryString
          }
        } */
        var _this = this;
        var e_1, _a;
        ///Questa è una pezza ma non mi piace devo farla bene:
        if (this.filterGrid != '' && typeof this.itemData != 'undefined') {
            return;
        }
        var filterList = anagraficaFilter[0]['configuration']['filterList'];
        if (typeof filterList == "undefined")
            return;
        //console.log('prima:', this.filterGrid);
        //console.log('prima:', this.filterGrid);
        if (filterList.includes('$')) {
            var oDataKeyWords = [/\$filter/gi, /\$top/gi, /\$skip/gi, /\$orderby/gi, /\$count/gi];
            //SE NON È PRESENTE ALCUN ODATA MA SOLO LE VARIABILI DA RIMPIAZZARE
            if ((oDataKeyWords.every(function (x) { return (filterList.match(x)) == null; }))) {
                var arrayFilterList = filterList.split('$');
                var matchesFilter_1 = '';
                //let arrayIdRif = anagraficaFilter[0]['configuration']['idTabRif']
                arrayFilterList.forEach(function (keyRif) {
                    console.log(_this.filterID);
                    var keyRef_WithoutSpecialCharacters = keyRif.replace(/[=?]/g, '');
                    if (_this.filterID[keyRef_WithoutSpecialCharacters]) {
                        var data = _this.filterID[keyRef_WithoutSpecialCharacters];
                        try {
                            matchesFilter_1 = filterList.replace('$' + keyRef_WithoutSpecialCharacters, data);
                        }
                        catch (error) {
                            console.error('ERRORE: ', error);
                            ////console.log('FilterID: ', this.filterID)
                        }
                    }
                });
                this.filterGrid = matchesFilter_1;
            }
            else {
                //Se è ODATA ANCHE Con altre semplici associazioni chiavi valore in query string
                var parameters = filterList.split('&');
                var tempQueryString = "";
                var noFilter = oDataKeyWords.slice(1, oDataKeyWords.length);
                var _loop_1 = function (param) {
                    var e_2, _a;
                    var p = param;
                    //tutte le keyword tranne $filter verranno semplicemente aggiunte cosi come sono
                    if (noFilter.some(function (reg) { return p.match(reg) != undefined; })) {
                        tempQueryString += p + "&";
                        return "continue";
                    }
                    console.log(this_1.filterID);
                    try {
                        for (var _b = __values(Object.keys(this_1.filterID)), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var key = _c.value;
                            //console.log(key,this.filterID[key]);
                            if (typeof this_1.filterID[key] !== 'undefined' && param.includes("$" + key))
                                p = param.replace("$" + key, this_1.filterID[key]);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    tempQueryString += p + "&";
                };
                var this_1 = this;
                try {
                    for (var parameters_1 = __values(parameters), parameters_1_1 = parameters_1.next(); !parameters_1_1.done; parameters_1_1 = parameters_1.next()) {
                        var param = parameters_1_1.value;
                        _loop_1(param);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (parameters_1_1 && !parameters_1_1.done && (_a = parameters_1.return)) _a.call(parameters_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                this.filterGrid = tempQueryString;
            }
        }
        else {
            this.filterGrid = filterList;
        }
        /*
        else{
  
        let regExp = /\(([^)]+)\)/;
        let matches = regExp.exec(filterList);
  
        //matches[1] contains the value between the parentheses
        if (matches) {
          let matchesFilter = ''
          if (matches[1].includes('$')) {
            const arrayFilterList = matches[1].split('$');
  
            //let arrayIdRif = anagraficaFilter[0]['configuration']['idTabRif']
            arrayFilterList.forEach(keyRif => {
              //////console.log(keyRif)
              if (this.filterID[keyRif]) {
                let data = this.filterID[keyRif];
  
                try {
                  matchesFilter = filterList.replace('$' + keyRif, data);
                } catch (error) {
                  console.error('ERRORE: ', error)
                  ////console.log('FilterID: ', this.filterID)
                }
  
  
  
              }
            })
  
            this.filterGrid = matchesFilter;
  
          }
        } else {
          if (filterList.includes('$')) {
            const arrayFilterList = filterList.split('$');
  
            //let arrayIdRif = anagraficaFilter[0]['configuration']['idTabRif']
            arrayFilterList.forEach(keyRif => {
              //////console.log(keyRif)
              if (this.filterID[keyRif]) {
                let data = this.filterID[keyRif];
  
                try {
                  filterList = filterList.replace('$' + keyRif, data);
                  this.filterGrid = filterList;
                } catch (error) {
                  console.error('ERRORE: ', error)
                  ////console.log('FilterID: ', this.filterID)
                }
  
  
  
              }
            })
  
  
  
          }
  
        }
  
  
      }
  
      if (routerParam.queryFilter) {
        if (anagraficaFilter[0]['configuration']['queryFilter']) {
          let arrayQueryFilter = anagraficaFilter[0]['configuration']['queryFilter']
  
          let newItemQ = ''
          let dataQueryFilter = JSON.parse(routerParam.queryFilter)
  
          arrayQueryFilter.forEach(idTab => {
            if (typeof dataQueryFilter[idTab['key']] != 'undefined') {
              newItemQ += idTab['key'] + '=' + dataQueryFilter[idTab['key']] + '&';
  
              ////////console.log(idTab['key'] + '=' + dataQueryFilter[idTab['key']])
            }
          });
  
  
  
          if (newItemQ) {
            this.filterGrid = '?' + newItemQ
          }
        }
  
      }
  
      if (routerParam.staticQueryFilter) {
        this.filterGrid += routerParam.staticQueryFilter
  
  
      }
      */
    };
    NicaMaster.prototype.setGlobalVariableFromParams = function (routerParam) {
        var _this = this;
        this.menuService.previousUrl$.subscribe(function (prevUrl) {
            _this.returnUrl = prevUrl;
        });
        this.params = routerParam;
        this.currentTabId = routerParam.currentTabId,
            this.currentTabName = routerParam.currentTabName;
        this.previusUrl = routerParam.prevUrl;
        this.anagraficaDati = this.templateService.getService(routerParam.service);
        if (!this.anagraficaDati) {
            if (routerParam.service) {
                this.SubjectCall = routerParam.service;
            }
            return;
        }
        /**Setto le Variabili globali dalla conFigurazione dell'anagrafica***/
        var anagraficaFilter = this.anagraficaDati.filter(function (r) { return r.configuration; });
        this.apiset = anagraficaFilter[0]['configuration']['api'];
        this.SubjectCall = anagraficaFilter[0]['configuration']['service'];
        this.type = anagraficaFilter[0]['configuration']['formType'];
        this.nCol = anagraficaFilter[0]['configuration']['nCol'];
        this.allowedAdvancedFilter = anagraficaFilter[0]['configuration']['allowedAdvancedFilter'];
        this.advancedXlsExportFilterTemplateName = anagraficaFilter[0]['configuration']['advancedXlsExportFilterTemplateName'];
        this.isAdvancedXlsExportAvailable = anagraficaFilter[0]['configuration']['isAdvancedXlsExportAvailable'];
        /* Ottengo in nome del servizio legato alla toolbar */
        this.toolbarComponentFilter = anagraficaFilter[0]['configuration']['toolbarSettings'];
        /*
           Ottengo in nome del servizio legato alla Tipo di template dai paramenti,se non è settato utilizzo quello della configurazione
           presente nell'anagrafica.
         */
        if (routerParam.templateView) {
            this.template = routerParam.templateView;
        }
        else {
            if (!this.anagraficaDati[0]['configuration']['template'] && !this.anagraficaDati[0]['configuration']['startTemplate']) {
                this.template = 'grid';
            }
            else {
                this.template = this.anagraficaDati[0]['configuration']['template'] || this.anagraficaDati[0]['configuration']['startTemplate'];
            }
        }
        /* Ottengo l'oggetto contente i bottoni della toobar */
        if (typeof this.toolbarComponentFilter != 'undefined') {
            this.serviceButtonsArray = this.anagraficaService.getService(this.toolbarComponentFilter.service);
        }
        /* Setto i filtri globali che arrivano dali paramentri */
        if (routerParam.filter) {
            if (routerParam.filter) {
                this.filterID = JSON.parse(routerParam.filter);
            }
            NicaFormComponent.formDataBackupObject = JSON.parse(JSON.stringify(this.filterID));
        }
        if (routerParam.id) {
            this.id = routerParam.id;
        }
        /*
      
          Se il template è di tipo Griglia o gli dynamicgrid costrusco i paramentri path o qstring per ottenere l'elenco/lista dei dati
          via API
      
        */
        if (this.template == 'grid' || this.template == 'dynamicGrid') {
            this.impostaFiltroGriglia(routerParam, anagraficaFilter);
            this.impostaTitoloGriglia(routerParam, anagraficaFilter);
        }
        else if (this.template == 'form' || this.template == 'component') {
            //Costrusco i dati costanti da inviare alla form.
            this.impostaDatiForm(routerParam, anagraficaFilter);
            var filterEditor = anagraficaFilter[0]['configuration']['filterEditor'];
            this.impostaFiltroForm(routerParam, filterEditor);
        }
        this.masterKey = anagraficaFilter[0]['configuration']['masterKey'];
        if (anagraficaFilter[0]['configuration']['helpDoc']) {
            this.helpDoc = anagraficaFilter[0]['configuration']['helpDoc'];
        }
        /*
          Se il template è di tipo form, ottengo i dati
        */
        if (this.template == 'form' || this.template == 'component') {
            this.impostaTitoloForm(anagraficaFilter);
        }
        if (routerParam.breadcrumb) {
            this.breadcrumbCaption = routerParam.breadcrumb;
        }
        else {
            this.breadcrumbCaption = anagraficaFilter[0]['configuration']['breadcrumbCaption'];
            this.idBreadcrumbGroup = anagraficaFilter[0]['configuration']['idBreadcrumbGroup'];
        }
        if (routerParam.queryFilter) {
            this.queryFilter = JSON.parse(routerParam.queryFilter);
        }
        var navComponent = sessionStorage.getItem('navComponent');
        if (navComponent) {
            this.cronNavigation = JSON.parse(navComponent);
            this.userComponentService.setNavComponent(this.cronNavigation);
        }
        this.userComponentService.componentRouter.forEach(function (res) {
            if (Array.isArray(res) && res.length > 0) {
                _this.cronNavigation = res.filter(function (res) { return res.idTab == routerParam.currentTabId; });
            }
        });
        if (this.cronNavigation.length > 0) {
            var navigations = this.cronNavigation.filter(function (res) { return res.idTab == _this.currentTabId; });
            var navigation = navigations[0].data;
            var checkItemIdex = navigation.findIndex(function (n) { return n.id == _this.idBreadcrumbGroup; });
            if (checkItemIdex == -1) {
                var nav = {
                    title: this.breadcrumbCaption,
                    cRouter: this.router.url.split('?')[0],
                    params: this.params,
                    idGroup: this.idBreadcrumbGroup,
                    idTab: this.currentTabId,
                    idData: this.SubjectCall,
                    active: true,
                };
                this.userComponentService.setComponentNavigation(nav);
            }
            else {
                var itemDataNav = {
                    title: this.breadcrumbCaption,
                    cRouter: this.router.url.split('?')[0],
                    params: this.params,
                    idGroup: this.idBreadcrumbGroup,
                    idTab: this.currentTabId,
                    idData: this.SubjectCall,
                    active: true,
                };
                this.userComponentService.setNavigationChildren(itemDataNav, this.idBreadcrumbGroup);
            }
        }
        else {
            var nav = {
                title: this.breadcrumbCaption,
                cRouter: this.router.url.split('?')[0],
                params: this.params,
                idGroup: this.idBreadcrumbGroup,
                idTab: this.currentTabId,
                idData: this.SubjectCall,
                active: true,
                items: []
            };
            this.userComponentService.setComponentNavigation(nav);
        }
        var navigationData = [];
        var navigationsFilter = this.cronNavigation.filter(function (res) { return res.idTab == _this.currentTabId; });
        if (navigationsFilter.length > 0) {
            var navigationData_1 = navigationsFilter[0].data;
            this.breadcrumbNavigation = navigationData_1;
            //console.log('breadcrumbNavigation', this.breadcrumbNavigation)
            this.tabNavigationChildrend = navigationData_1.filter(function (res) { return res.idGroup == _this.idBreadcrumbGroup; });
        }
        //16 = è l'id del Bottone Ritorna della toolbar di Alessandro
        this.buttonToolbarBottomGrid = [16]; /* [
          {
            id: 1,
            location: "after",
            widget: "dxButton",
            locateInMenu: "never",
            useSubmitBehavior: true,
            template: false,
            options:
            {
              stylingMode: "text",
              text: "Indietro" ,
              icon: "glyphicon icon-annulla-form",
              visible: typeof this.itemData != 'undefined' ? false : true, //pezzottissimo
              onClick: ($event) => {
    
    
                //this.emettiChiusuraCaption('close');
    
                this.returnPrevUrl()
              },
    
    
            }
    
    
          },
          {
            id: 2,
            location: "after",
            widget: "dxButton",
            locateInMenu: "never",
            useSubmitBehavior: true,
            template: false,
            options:
            {
              stylingMode: "text",
              text: 'Chiudi tutto',
              icon: "close",
              visible: false,
              onClick: ($event) => {
    
    
    
    
                this.emettiChiusuraCaption('close')
              },
    
    
            }
    
    
          },
    
    
    
    
        ]
     */
    };
    NicaMaster.prototype.onBreadCrumbCaptionClicked = function (evt) {
        this.loader.show();
        console.warn(evt);
        this.loader.hide();
    };
    NicaMaster.prototype.optionalButtonClick = function (em) {
        var _this = this;
        if (em.infoButton == 'grigliaDropDownButtonInit') {
            var buttons = em.buttons;
            var dataGrid = em.data;
            var componentMenu = em.componentMenu;
            this.SetToolbarButtons(buttons, dataGrid, componentMenu, em.componentDrop, true);
            return;
        }
        if (em.infoButton.event == 1) {
            var data = [{
                    idTabRif: em.datiGriglia.id,
                    nomeTabRif: em.infoButton.costantValue,
                    dati: em.datiGriglia,
                    value: em.infoButton.value,
                    infoButton: em.infoButton
                }];
            this.openFunction(data);
        }
        if (em.infoButton.event == 2) {
            alert('Funzione non disponibile, in lavorazione', 'Attenzione!');
        }
        if (em.infoButton.event == 3) {
            var template_1 = em.value;
            var currentElement_1 = em.datiGriglia;
            var dataSource = void 0;
            var event_1 = 'Elenco';
            ////console.log('BottoneCLiccato', em)
            this.cronNavigation[0].data.forEach(function (nav) {
                if (nav.id == em.infoButton.dataSource && em.infoButton.value != 'dynamicGrid') {
                    template_1 = 'form';
                    currentElement_1 = JSON.parse(nav.params.data);
                    event_1 = 'Modifica';
                }
                if (nav.items) {
                    var items = nav.items;
                    items.forEach(function (item) {
                        if (item.id == em.infoButton.dataSource && em.infoButton.value != 'dynamicGrid') {
                            ////console.log('cronNavigationitems', item)
                            template_1 = 'form';
                            currentElement_1 = JSON.parse(item.params.data);
                            event_1 = 'Modifica';
                        }
                    });
                }
            });
            if (this.anagraficaDati[0]['configuration']['queryFilter']) {
                var arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter']; // prendo i campi di riferimento da passare alla Form dalla configurazione
                var newItem_1;
                arrayIdRif.forEach(function (idTab) {
                    var _a;
                    if (typeof currentElement_1[idTab['value']] != 'undefined') {
                        newItem_1 = __assign({}, _this.filterID, (_a = {}, _a[idTab['key']] = currentElement_1[idTab['value']], _a));
                        _this.filterID = newItem_1;
                    }
                });
            }
            var componentName = em.infoButton.componentName;
            this.refreshPage(currentElement_1, 'Elenco', em.infoButton.dataSource, em.infoButton.value, '', componentName);
        }
        if (em.infoButton.event == 4) {
            var datajS_1;
            if (em.infoButton.costantValue) {
                var currentElement_2 = em.datiGriglia;
                var costantValue = em.infoButton.costantValue;
                costantValue.forEach(function (res) {
                    var _a;
                    datajS_1 = __assign({}, datajS_1, (_a = {}, _a[res['key']] = currentElement_2[res['value']], _a));
                });
            }
            this.router.navigate([em.infoButton.path], {
                queryParams: {
                    id: em.infoButton.service,
                    masterKey: 'id',
                    filter: JSON.stringify(this.params.filter),
                    data: JSON.stringify(datajS_1),
                    currentTabId: em.infoButton.service,
                    currentTabName: em.infoButton.name,
                    componentName: em.infoButton.componentName
                },
                skipLocationChange: true,
                replaceUrl: false
            }).then(function (res) {
            });
        }
    };
    NicaMaster.prototype.optionalButtonClickToolBar = function (e) {
        ////console.log('optionalButtonClickToolBar', e);
        switch (e) {
            case 1:
                if (this.filterGrid.includes('?TipoAttivita=P')) {
                    this.filterGrid = this.filterGrid.replace('?TipoAttivita=P', '');
                    this.nicaAnagrafica.refresh();
                    var allElm_1 = document.querySelectorAll(".dx-state-selected");
                    allElm_1.forEach(function (el) {
                        el.classList.remove('dx-state-selected');
                    });
                    return;
                }
                else if (this.filterGrid.includes('?TipoAttivita')) {
                    this.filterGrid = this.filterGrid.split('?')[0];
                }
                var currentFilterGridProd = this.filterGrid;
                this.filterGrid = currentFilterGridProd + '?TipoAttivita=P';
                this.nicaAnagrafica.refresh();
                break;
            case 2:
                if (this.filterGrid.includes('?TipoAttivita=T')) {
                    this.filterGrid = this.filterGrid.replace('?TipoAttivita=T', '');
                    this.nicaAnagrafica.refresh();
                    var allElm_2 = document.querySelectorAll(".dx-state-selected");
                    allElm_2.forEach(function (el) {
                        el.classList.remove('dx-state-selected');
                    });
                    return;
                }
                else if (this.filterGrid.includes('?TipoAttivita')) {
                    this.filterGrid = this.filterGrid.split('?')[0];
                }
                var currentFilterGridTr = this.filterGrid;
                this.filterGrid = currentFilterGridTr + '?TipoAttivita=T';
                this.nicaAnagrafica.refresh();
                break;
            case 3:
                if (this.filterGrid.includes('?TipoAttivita=S')) {
                    this.filterGrid = this.filterGrid.replace('?TipoAttivita=S', '');
                    this.nicaAnagrafica.refresh();
                    var allElm_3 = document.querySelectorAll(".dx-state-selected");
                    allElm_3.forEach(function (el) {
                        el.classList.remove('dx-state-selected');
                    });
                    return;
                }
                else if (this.filterGrid.includes('?TipoAttivita')) {
                    this.filterGrid = this.filterGrid.split('?')[0];
                }
                var currentFilterGridDest = this.filterGrid;
                this.filterGrid = currentFilterGridDest + '?TipoAttivita=S';
                this.nicaAnagrafica.refresh();
                break;
            case 4:
                if (this.filterGrid.includes('?TipoAttivita=I')) {
                    this.filterGrid = this.filterGrid.replace('?TipoAttivita=I', '');
                    this.nicaAnagrafica.refresh();
                    var allElm_4 = document.querySelectorAll(".dx-state-selected");
                    allElm_4.forEach(function (el) {
                        el.classList.remove('dx-state-selected');
                    });
                    return;
                }
                else if (this.filterGrid.includes('?TipoAttivita')) {
                    this.filterGrid = this.filterGrid.split('?')[0];
                }
                var currentFilterGridIn = this.filterGrid;
                this.filterGrid = currentFilterGridIn + '?TipoAttivita=I';
                this.nicaAnagrafica.refresh();
                break;
            case 5:
                if (this.filterGrid.includes('?TipoAttivita')) {
                    this.filterGrid = this.filterGrid.split('?')[0];
                }
                this.nicaAnagrafica.refresh();
                var allElm = document.querySelectorAll(".dx-state-selected");
                allElm.forEach(function (el) {
                    el.classList.remove('dx-state-selected');
                });
                break;
            default:
                break;
        }
    };
    NicaMaster.prototype.SetToolbarButtons = function (buttons, dataGrid, component, component2, forceShow) {
        var _this = this;
        if (buttons === void 0) { buttons = []; }
        if (dataGrid === void 0) { dataGrid = null; }
        var buttonArray = [];
        var newButton = [];
        buttonArray = buttons;
        if (this.serviceButtonsArray) {
            buttonArray = this.serviceButtonsArray;
        }
        else {
            buttonArray = buttons;
        }
        buttonArray.forEach(function (button, i) {
            button.text = button.text ? button.text : button.name;
            if (button.location == 'top') {
                if (typeof button['buttonSettings'] != 'undefined') {
                    var arrayCondition = button['buttonSettings']['displayButtons']['arrayCondition'];
                    var formData_1;
                    if (dataGrid) {
                        formData_1 = dataGrid;
                    }
                    else {
                        formData_1 = _this.filterID;
                    }
                    var conditions_1 = '';
                    var operatorEnd_1 = '&&';
                    if (typeof button['buttonSettings']['displayButtons']['typeOfConditions'] != 'undefined') {
                        operatorEnd_1 = button['buttonSettings']['displayButtons']['typeOfConditions'];
                    }
                    var countConditions_1 = arrayCondition.length - 1;
                    arrayCondition.forEach(function (condition, x) {
                        var key = condition.key;
                        var conditionOperator = condition.operator;
                        var value = condition.value;
                        var operator = x < countConditions_1 ? operatorEnd_1 : '';
                        if (typeof formData_1[key] == 'undefined') {
                            conditions_1 += false;
                        }
                        else {
                            var cond = _this.evalIII(formData_1[key], conditionOperator, value);
                            conditions_1 += cond + operator;
                        }
                    });
                    try {
                        if (eval(conditions_1)) {
                            button.visible = true;
                        }
                        else {
                            button.visible = false;
                        }
                        if (!button.widget) {
                            button.widget = 'button';
                        }
                    }
                    catch (ex) {
                        console.warn(ex);
                    }
                }
            }
        });
        this.buttonToolbarUp = buttonArray.filter(function (buttons) { return buttons.location == 'top'; });
        this.buttonToolbarBottom = buttonArray.filter(function (buttons) { return buttons.location == 'bottom'; });
        if (this.template == 'form' || this.template == 'dynamicGrid' || forceShow) {
            this.showToolBar = true;
        }
        if (this.template == 'grid') {
            //this.showToolBar = true
        }
    };
    NicaMaster.prototype.inizializza = function () {
        this.apiset = this.itemData[0].NomeTabella;
        this.id = this.itemData[0].IdTabella;
        this.rowData = this.itemData[0].data;
        this.SubjectCall = 'soggettoForm';
        //////////console.log)
        //this.formSoggetto.initialize();
    };
    NicaMaster.prototype.formEvent = function (e) {
        var _this = this;
        if (e.name == 'infoCF' || e.name == 'infoPiva') {
            var current = void 0;
            if (e.name == 'infoCF') {
                current = e.data.codiceFiscale.trim();
            }
            if (e.name == 'infoPiva') {
                current = e.data.partitaIVA.trim();
            }
            this._overlaySidePanelService.setTitle("Info dati  fiscali azienda");
            var data = [
                {
                    destComponent: 'AnaSoggetto',
                    traceMessage: 'infoCF',
                    dati: current,
                }
            ];
            this._overlaySidePanelService.sendDataToComponent(data);
            this._overlaySidePanelService.setToolBarVisible(false);
            this._overlaySidePanelService.setContent(NicaInfoAnagraficaAziendaComponent);
            this._overlaySidePanelService.setPopupHeight('60vh');
            this._overlaySidePanelService.setPopupWidth('60vw');
            this._overlaySidePanelService.show();
            setTimeout(function () {
                _this._overlaySideFormService._hrefComponent.instance.class = 'soggetto-form';
                _this._overlaySideFormService._hrefComponent.instance.emittedData.subscribe(function (ress) {
                    ////console.log('emittedData', ress);
                    ////////console.logmessage)
                    if (ress) {
                        if (ress['soloDati']) {
                            //let desc = "?$filter=((contains(tolower(descrizione)," + "'" + ress['localita'].toLowerCase() + "')))"
                            var desc = "?$filter=( descrizione eq '" + ress['localita'] + "' )";
                            _this.anagraficaService.getElenco('Comune', '', desc).then(function (ree) {
                                if (ree['items']) {
                                    _this.formSoggetto.formEdit.instance.updateData('istatComune', ree['items'][0]['id']);
                                    _this.formSoggetto.formEdit.instance.updateData('comune', ree['items'][0]['descrizione']);
                                    _this.formSoggetto.formEdit.instance.updateData('stato', 'IT');
                                    _this.formSoggetto.formEdit.instance.updateData('cap', ree['items'][0]['cap']);
                                }
                            });
                            _this.formSoggetto.formEdit.instance.updateData('ragioneSociale', ress['ragione_Sociale']);
                            _this.formSoggetto.formEdit.instance.updateData('isoFiscale', 'IT');
                            _this.formSoggetto.formEdit.instance.updateData('siglaProvincia', ress['prov']);
                            _this.formSoggetto.formEdit.instance.updateData('indirizzo', ress['indirizzo']);
                            _this.formSoggetto.formEdit.instance.updateData('comune', ress['localita']);
                            _this.formSoggetto.formEdit.instance.updateData('partitaIVA', ress['tax']);
                            _this.formSoggetto.formEdit.instance.updateData('codiceFiscale', ress['vat']);
                            _this.formSoggetto.formEdit.instance.updateData('pec', ress['pec']);
                            //this.formSoggetto.formEdit.instance.updateData('cap', ress['cap']);
                            _this.formSoggetto.formEdit.instance.updateData('civico', ress['civico']);
                        }
                        if (ress['soloPec']) {
                            _this.formSoggetto.formEdit.instance.updateData('pec', ress['pec']);
                        }
                        _this._overlaySidePanelService.close();
                    }
                });
            }, 300);
        }
        ////////console.log(e)
        if (e.name == 'ottieniCoordinate') {
            if (this.formSoggetto.formEdit.formData['latidudine'] < -90 || this.formSoggetto.formEdit.formData['latidudine'] > 90) {
                alert('Per la latitudine specificare un numero compreso tra -90 e 90', 'Attenzione');
                return;
            }
            if (this.formSoggetto.formEdit.formData['longitudine'] < -180 || this.formSoggetto.formEdit.formData['longitudine'] > 180) {
                alert('Per la longitudine specificare un numero compreso tra -180 e 180', 'Attenzione');
                return;
            }
            console.warn(e);
            var address = e.data.indirizzo.concat(' ' + e.data.civico) + ',' + e.data.cap + ' ' + e.data.comune + ' ' + e.data.siglaProvincia;
            this._overlaySidePanelService.setTitle("Coordinate Geografiche");
            var data = [
                {
                    destComponent: 'AnaSoggetto',
                    traceMessage: 'ottieniCoordinate',
                    dati: (e.data.latidudine && e.data.longitudine) ? { lat: e.data.latidudine, lng: e.data.longitudine, address: address } : address
                }
            ];
            this._overlaySidePanelService.setTitle("Ottieni Coordinate");
            this._overlaySidePanelService.sendDataToComponent(data);
            this._overlaySidePanelService.setToolBarVisible(false);
            this._overlaySidePanelService.setContent(NicaMapsComponent);
            this._overlaySideFormService.setPopupWidth(850);
            this._overlaySideFormService.setPopupHeight(870);
            setTimeout(function () {
                _this._overlaySideFormService._hrefComponent.instance.coordinateEmitter.subscribe(function (coordinate) {
                    console.warn(coordinate);
                    if (coordinate) {
                        _this.formSoggetto.formEdit.instance.updateData('latidudine', "" + coordinate.lat());
                        _this.formSoggetto.formEdit.instance.updateData('longitudine', "" + coordinate.lng());
                        _this._overlaySideFormService.close();
                    }
                    else if (typeof coordinate == "undefined") {
                        console.warn("DEVO CHIUDERE");
                        _this._overlaySideFormService.close();
                    }
                });
            }, 300);
            this._overlaySidePanelService.show();
        }
        if (e.name == 'submittedEditOk') {
            var data_1 = e.formData;
            /**Gestisco i queryurl Filtri in Base al Edit**/
            if (this.anagraficaDati[0]['configuration']['queryFilter']) {
                var arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter']; // prendo i campi di riferimento da passare alla Form dalla configurazione
                var newItem_2;
                arrayIdRif.forEach(function (idTab) {
                    var _a;
                    if (typeof data_1[idTab['value']] != 'undefined') {
                        newItem_2 = __assign({}, _this.filterID, (_a = {}, _a[idTab['key']] = data_1[idTab['value']], _a));
                        _this.filterID = newItem_2;
                    }
                });
            }
            ///Questa cosa se l'ho fatta non va bene fatta così quindi appena ho un pò di tempo la commento e vedo che succede.
            var template = this.template;
            if (this.SubjectCall == 'lotto') {
                template = 'grid';
            }
            if (this.SubjectCall == 'magazzinorifiuti') {
                template = 'grid';
            }
            if (this.SubjectCall == 'autista') {
                template = 'grid';
            }
            if (this.SubjectCall == 'cantiere') {
                template = 'grid';
            }
            this.refreshPage(data_1, 'Modifica', this.SubjectCall, template);
            return;
        }
        if (e.name == 'submittedInsertOk') {
            var data_2 = e.formData;
            this.id = data_2[this.masterKey];
            /**Gestisco i queryurl Filtri in Base al Edit**/
            if (this.anagraficaDati[0]['configuration']['queryFilter']) {
                var arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter']; // prendo i campi di riferimento da passare alla Form dalla configurazione
                var newItem_3;
                arrayIdRif.forEach(function (idTab) {
                    var _a;
                    if (typeof data_2[idTab['value']] != 'undefined') {
                        newItem_3 = __assign({}, _this.filterID, (_a = {}, _a[idTab['key']] = data_2[idTab['value']], _a));
                        _this.filterID = newItem_3;
                    }
                });
            }
            if (this.id)
                this.filterID['isEdit'] = true;
            var template = this.template;
            if (this.SubjectCall == 'lotto') {
                template = 'grid';
            }
            if (this.SubjectCall == 'magazzinorifiuti') {
                template = 'grid';
            }
            if (this.SubjectCall == 'autista') {
                template = 'grid';
            }
            if (this.SubjectCall == 'cantiere') {
                template = 'grid';
            }
            this.refreshPage(data_2, 'Modifica', this.SubjectCall, template);
            return;
        }
        if (e.eventName == 'submittedInsertOk') {
            this.id = e[this.masterKey];
            var data_3 = e;
            /**Gestisco i queryurl Filtri in Base al Edit**/
            if (this.anagraficaDati[0]['configuration']['queryFilter']) {
                var arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter']; // prendo i campi di riferimento da passare alla Form dalla configurazione
                var newItem_4;
                arrayIdRif.forEach(function (idTab) {
                    var _a;
                    if (typeof data_3[idTab['value']] != 'undefined') {
                        newItem_4 = __assign({}, _this.filterID, (_a = {}, _a[idTab['key']] = data_3[idTab['value']], _a));
                        _this.filterID = newItem_4;
                    }
                });
            }
            if (this.SubjectCall == 'soggetto') {
                this.refreshPage(e, 'Modifica', this.SubjectCall, 'form');
                var customMessage_1 = custom({
                    title: "Attenzione!",
                    messageHtml: "Anagrafica soggetto salvata, inserisci l'unica locale...",
                });
                customMessage_1.show();
                setTimeout(function () {
                    _this.refreshPage([], 'Inserisci', 'sede', 'form');
                    customMessage_1.hide();
                }, 1500);
                return;
            }
            this.refreshPage(e, 'Modifica', this.SubjectCall, 'form');
            return;
        }
        if (e.eventName == 'submittedEditOk') {
            var data_4 = this.formSoggetto.dataSet;
            /**Gestisco i queryurl Filtri in Base al Edit**/
            if (this.anagraficaDati[0]['configuration']['queryFilter']) {
                var arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter']; // prendo i campi di riferimento da passare alla Form dalla configurazione
                var newItem_5;
                arrayIdRif.forEach(function (idTab) {
                    var _a;
                    if (typeof data_4[idTab['value']] != 'undefined') {
                        newItem_5 = __assign({}, _this.filterID, (_a = {}, _a[idTab['key']] = data_4[idTab['value']], _a));
                        _this.filterID = newItem_5;
                    }
                });
            }
            this.refreshPage(data_4, 'Modifica', this.SubjectCall, 'form');
            return;
        }
        if (e.name == 'return') {
            var copyF = this.filterID;
            //Se nei filtri ho movimento true allora chiudi la pagina e torna ai movimenti
            if (copyF['movimento']) {
                e.event = 5;
                this.buttonEmitted(e);
                return;
            }
            var data = [];
            /**Gestisco i queryurl Filtri in Base al filtri iniziali**/
            if (this.anagraficaDati[0]['configuration']['queryFilter']) {
                var arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter']; // prendo i campi di riferimento da passare alla Form dalla configurazione
                var newItem_6;
                var data_5;
                if (typeof this.formSoggetto != 'undefined') {
                    data_5 = this.formSoggetto.dataSet;
                }
                else {
                    data_5 = this.formAnagrafica.dataSet;
                }
                //let data = this.filterID
                arrayIdRif.forEach(function (idTab) {
                    var _a;
                    if (typeof data_5[idTab['value']] != 'undefined') {
                        //this.filterID[idTab['key']]=data[idTab['value']]
                        newItem_6 = __assign({}, _this.filterID, (_a = {}, _a[idTab['key']] = data_5[idTab['value']], _a));
                        _this.filterID = newItem_6;
                    }
                });
            }
            this.refreshPage('', 'Elenco', this.SubjectCall, 'grid');
            return;
        }
        if (e.evento == 'coordinateGeografiche') {
            alert('Funzione non ancora disponibile', 'Attenzione!');
        }
        if (e.event == 'copiaDatiAzienda') {
            var icon = e.component.option('icon');
            if (icon == 'glyphicon mdi mdi mdi-checkbox-marked') {
                this.formSoggetto.formEdit.instance.updateData('descrizione', '');
                this.formSoggetto.formEdit.instance.updateData('indirizzo', '');
                this.formSoggetto.formEdit.instance.updateData('civico', '');
                this.formSoggetto.formEdit.instance.updateData('comune', '');
                this.formSoggetto.formEdit.instance.updateData('istatComune', '');
                this.formSoggetto.formEdit.instance.updateData('cap', '');
                this.formSoggetto.formEdit.instance.updateData('siglaProvincia', '');
                this.formSoggetto.formEdit.instance.updateData('stato', '');
                e.component.option('icon', 'glyphicon mdi mdi-checkbox-blank-outline');
                return;
            }
            else {
                var data = e.data;
                var filter_1 = data['idSoggetto'];
                this.anagraficaService.getValue('soggetto', filter_1, '').then(function (res) {
                    _this.formSoggetto.formEdit.instance.updateData('descrizione', res['ragioneSociale']);
                    _this.formSoggetto.formEdit.instance.updateData('indirizzo', res['indirizzo']);
                    _this.formSoggetto.formEdit.instance.updateData('civico', res['civico']);
                    _this.formSoggetto.formEdit.instance.updateData('comune', res['comune']);
                    _this.formSoggetto.formEdit.instance.updateData('istatComune', res['istatComune']);
                    _this.formSoggetto.formEdit.instance.updateData('cap', res['cap']);
                    _this.formSoggetto.formEdit.instance.updateData('siglaProvincia', res['siglaProvincia']);
                    _this.formSoggetto.formEdit.instance.updateData('stato', res['stato']);
                    e.component.option('icon', 'glyphicon mdi mdi mdi-checkbox-marked');
                });
                return;
            }
        }
        if (e.name == 'formDataChanged') {
            this.tempData = e.formDataChanged;
            return;
        }
        if (e.name == 'formDataInit') {
            this.currentElement = e.formData;
            //this.SetToolbarButtons(this.serviceButtonsArray, e.formData);
        }
        if (e.name == 'returnButton') {
            e.component.option('text', "Ritorna all'elenco");
        }
        if (e.name == 'formContentInitializzed') {
            this.SetToolbarButtons(this.serviceButtonsArray, e.formData);
        }
    };
    NicaMaster.prototype.formInitializzed = function (event) {
        this.SetToolbarButtons(this.serviceButtonsArray, event.formData);
    };
    NicaMaster.prototype.emettiChiusuraCaption = function (e) {
        //console.log('emettiChiusuraCaption', e)
        //N.B La chiusura dei componenti in una app-caption (come footer) 
        //è demandata ai componenti stessi 
        if (e == 'closePopUpOverlay') {
        }
        if (e == 'close') {
            var event_2 = { event: 5 };
            this.buttonEmitted(event_2);
        }
        if (e == 'closeToolbar') {
            if (!this.isOpen) {
                this.openToolBar();
            }
            else {
                this.closeToolBar();
            }
        }
        if (e == 'ritorna') {
            this.returnPrevUrl();
        }
        /* if (e == 'return') {
          this.showFormEdit = false
        }
    
        if (e == 'sfoglia') {
          this.showFormEdit = false
        }
    
        if (e == 'nuovo') {
    
    
    
    
    
        } */
    };
    NicaMaster.prototype.openToolBar = function (event) {
        var _this = this;
        if (typeof event != 'undefined') {
            event.preventDefault();
            event.stopPropagation();
        }
        this.InAttesaOpen = true;
        this.timeInterval = setTimeout(function () {
            if (!_this.isOpen && _this.InAttesaOpen)
                _this.isOpen = true;
        }, 100);
    };
    NicaMaster.prototype.closeToolBar = function (event) {
        var _this = this;
        if (typeof event != 'undefined') {
            event.preventDefault();
            event.stopPropagation();
        }
        this.InAttesaOpen = false;
        clearTimeout(this.timeInterval);
        setTimeout(function () {
            if (_this.isOpen)
                _this.isOpen = false;
        }, 100);
    };
    NicaMaster.prototype.toolbarEvent = function ($event) {
        /* if(this.isOpen){
           this.closeToolBar()
         }else{
           this.openToolBar()
         }*/
    };
    NicaMaster.prototype.buttonEmitted = function (em) {
        var _this = this;
        if (em.infoButton == 'grigliaDropDownButtonInit') {
            var buttons = em.buttons;
            var dataGrid = em.data;
            var componentMenu = em.componentMenu;
            ////console.log('grigliaDropDownButtonInit', buttons)
            ////console.log('grigliaDropDownDataGrid', dataGrid);
            ////console.log('grigliaDropDownComponent', componentMenu)
            this.SetToolbarButtons(this.serviceButtonsArray, dataGrid, componentMenu, em.componentDrop);
            componentMenu.option('items', this.buttonToolbarUp);
            return;
        }
        //console.log('buttonEmitted',em)
        var datiGriglia;
        if (em.infoButton) {
            datiGriglia = em.datiGriglia;
            em = em.infoButton;
        }
        if (em.event == 0 && this.InviaA) {
            var messaggioChiusura = {
                codeMessage: 1,
                destComponent: this.InviaA,
                traceMessage: em.value
            };
            this.userComponentService.emitMessage(messaggioChiusura);
        }
        if (em.event == 1) {
            var currentElement_3;
            var queryString = '';
            var values_1 = {};
            if (this.template == 'form') {
                currentElement_3 = typeof this.formSoggetto != 'undefined' ? this.formSoggetto.dataSet : this.formAnagrafica.dataSet;
            }
            else if (this.template == 'grid') {
                if (datiGriglia) {
                    currentElement_3 = datiGriglia;
                }
                else {
                    currentElement_3 = this.filterID;
                }
            }
            else if (this.template == 'dynamicGrid') {
                currentElement_3 = this.dynamicComponent.datasource;
            }
            else {
                currentElement_3 = this.filterID;
            }
            if (typeof em.queryString != 'undefined') {
                var myqueryString = em.queryString;
                for (var x in currentElement_3) {
                    if (myqueryString.includes(x)) {
                        myqueryString = myqueryString.replace('$' + x, currentElement_3[x]);
                    }
                }
                queryString = myqueryString;
            }
            if (typeof em.costantValue != 'undefined') {
                var costantValue = em.costantValue;
                costantValue.forEach(function (element) {
                    var _a;
                    var keyEle = element['key'];
                    var val = '';
                    if (typeof currentElement_3[element['value']] != 'undefined') {
                        val = currentElement_3[element['value']];
                    }
                    else {
                        val = element['value'];
                    }
                    values_1 = __assign({}, values_1, (_a = {}, _a[keyEle] = val, _a));
                });
            }
            var InstanceDatadata = {
                queryString: queryString,
                dataJson: values_1,
            };
            var dataTosend = [{
                    dati: currentElement_3
                }];
            this.openComponentInPopUP(em['componentName'], dataTosend, InstanceDatadata, '800', em['name'], false, false);
            //this.openFunction(data)
        }
        if (em.event == 2) {
            alert('Funzione non disponibile, in lavorazione', 'Attenzione!');
        }
        if (em.event == 3) {
            var template = em.templateComponent;
            var currentElement_4;
            var currentNav = void 0;
            var event_3 = 'Elenco';
            if (this.template == 'form') {
                if (typeof this.formSoggetto == 'undefined') {
                    currentElement_4 = this.formAnagrafica.dataSet;
                }
                else {
                    currentElement_4 = this.formSoggetto.formEdit.formData;
                }
            }
            else if (this.template == 'grid') {
                if (datiGriglia) {
                    currentElement_4 = datiGriglia;
                }
                else {
                    currentElement_4 = this.filterID;
                }
            }
            else if (this.template == 'dynamicGrid') {
                currentElement_4 = this.dynamicComponent.datasource;
            }
            else {
                currentElement_4 = this.filterID;
            }
            var id = this.idBreadcrumbGroup ? this.idBreadcrumbGroup : this.SubjectCall;
            /**Gestisco i queryurl Filtri in Base al Edit**/
            if (this.anagraficaDati[0]['configuration']['queryFilter']) {
                var arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter']; // prendo i campi di riferimento da passare alla Form dalla configurazione
                var newItem_7;
                arrayIdRif.forEach(function (idTab) {
                    var _a;
                    if (typeof currentElement_4[idTab['value']] != 'undefined') {
                        //this.filterID[idTab['key']]=data[idTab['value']]
                        newItem_7 = __assign({}, _this.filterID, (_a = {}, _a[idTab['key']] = currentElement_4[idTab['value']], _a));
                        _this.filterID = newItem_7;
                    }
                });
                ////console.log(this.filterID)
            }
            //Pezzotto maligno ma utile, rimuove l'ultimo livello dopo L'unità locale  
            if (this.SubjectCall == 'sede') {
                if (this.breadcrumbNavigation.length >= 3) {
                    var id_1 = this.SubjectCall;
                    this.userComponentService.removeLastItemComponentNavigation(this.currentTabId);
                }
            }
            var buttonParams = em;
            this.refreshPage(currentElement_4, event_3, em.service, template, buttonParams, buttonParams.componentName);
            if (!this.isOpen) {
                this.openToolBar();
            }
            else {
                this.closeToolBar();
            }
        }
        if (em.event == 4) {
            if (em.value == '') {
                return;
            }
            var datajS_2;
            var currentEl_1;
            if (this.template == 'form') {
                currentEl_1 = this.formSoggetto.formEdit.formData;
            }
            else if (this.template == 'grid') {
                if (datiGriglia) {
                    currentEl_1 = datiGriglia;
                }
                else {
                    currentEl_1 = this.filterID;
                }
            }
            else if (this.template == 'dynamicGrid') {
                currentEl_1 = this.dynamicComponent.datasource;
            }
            else {
                currentEl_1 = this.filterID;
            }
            if (em.costantValue) {
                var costantValue = em.costantValue;
                costantValue.forEach(function (res) {
                    var _a, _b;
                    if (typeof currentEl_1[res['value']] != 'undefined') {
                        datajS_2 = __assign({}, datajS_2, (_a = {}, _a[res['key']] = currentEl_1[res['value']], _a));
                    }
                    else {
                        datajS_2 = __assign({}, datajS_2, (_b = {}, _b[res['key']] = _this.filterID[res['value']], _b));
                    }
                });
            }
            var dataToSend = JSON.stringify(datajS_2);
            var queryFilter = JSON.stringify(this.filterID);
            var navigationParams = {
                api: this.apiset,
                service: em.service,
                masterKey: 'id',
                filter: queryFilter,
                queryFilter: JSON.stringify(this.queryFilter),
                descEvent: em.text,
                templateView: em.templateComponent,
                titoloDaPortare: '',
                data: dataToSend,
                prevUrl: this.previusUrl,
                currentTabId: this.currentTabId,
                currentTabName: this.currentTabName,
                componentName: em.componentName
            };
            this.router.navigate([em.path], {
                queryParams: navigationParams,
                skipLocationChange: true,
                replaceUrl: true
            }).then(function (res) {
            });
        }
        if (em.event == 5) {
            ////console.log('console', em);
            var data = this.filterID;
            var dataJS_1 = this.filterID;
            var datas_1;
            if (em.costantValue) {
                var costantValue = em.costantValue;
                costantValue.forEach(function (res) {
                    var _a;
                    //valori statici da passare
                    datas_1 = __assign({}, dataJS_1, (_a = {}, _a[res['key']] = res['value'], _a));
                });
            }
            var cUrl_1 = this.router.url.split('?')[0];
            var navigationParams_1 = {
                id: this.id,
                masterKey: 'id',
                api: this.apiset,
                service: this.SubjectCall,
                filter: this.params.filter,
                data: this.params.data,
                currentTabId: this.currentTabId,
                currentTabName: this.currentTabName,
                componentName: this.currentTabName,
                close: true
            };
            if (typeof this.itemData != 'undefined') {
                this.userComponentService.destroyCurrentOpenPopUpByGuid(this.currentTabId);
                this.userComponentService.removeNavigationComponent('', this.currentTabId);
                var closeData = {
                    name: 'closeTab',
                    service: this.SubjectCall,
                    filterData: this.filterID
                };
                this.onAllEvent.emit(closeData);
                return;
            }
            this.router.navigate(['/'], {
                skipLocationChange: false,
                replaceUrl: true
            }).then(function () {
                // Forzo a naviagare verso questa url per aggiornare i dati. 
                //sono costretto a ricaricare in maniera forzata il componente in attesa di idee
                var navigationExtras = {
                    queryParams: navigationParams_1,
                    skipLocationChange: false,
                    replaceUrl: true
                };
                _this.router.navigate([cUrl_1], navigationExtras);
            });
        }
        /*
        if (em.event == 7) {
          this.popupVisibleForm = !this.popupVisibleForm
        }
        */
    };
    NicaMaster.prototype.setVariableDynamicGrid = function () {
        ////console.log('filterGrid', this.filterGrid);
        ////console.log('filterID', this.filterID['idAutorizzazione']);
        this.filterKey = this.filterID['idAutorizzazione'];
        this.campo = {
            type: 'campoComponent',
            labelVisible: false,
            colSpan: "1",
            dataField: 'AutorizzazioneAreaCer',
            validation: [{
                    type: 'required',
                    message: "My custom message"
                }],
            colVisible: false,
            width: '1700px',
            dynamic: {
                dataSource: 'autorizzazionecer',
                autocomplete: false,
                checkValue: {
                    checkValueMessage: '',
                    forceInsert: false
                },
                valueExpr: '',
                campoTabRif: 'id',
                displayExpr: 'descrizione',
                caption: "Lista Autorizzazioni EER Zona",
                filter: '',
                componentType: 'dynamicGrid',
                enableEditor: true,
                settingGrid: {
                    campoTabRif: 'idAutorizzazione',
                    masterKey: 'cer',
                    keyUnique: '',
                    mode: 'cell',
                    remoteOperations: false,
                    hoverStateEnabled: true,
                    rowAlternationEnabled: true,
                    repaintChangesOnly: true,
                    allowUpdating: true,
                    allowDeleting: true,
                    allowAdding: false,
                    height: 505,
                    showFilterSearch: false,
                }
            }
        };
    };
    NicaMaster.prototype.emittedDynamicGridInit = function (event) {
        var dataGrid = event.component.getDataSource().items;
        //this.SetToolbarButtons(this.serviceButtonsArray, dataGrid);
    };
    NicaMaster.prototype.messageFromComponent = function () {
        var _this = this;
        this.userComponentService.castMessage.subscribe(function (message) {
            if (message.destComponent == 'AnaSoggetto' && message.traceMessage == 'infoCF' || message.destComponent == 'AnaSoggetto' && message.traceMessage == 'infoPiva') {
                _this._overlaySidePanelService.close();
                ////////console.logmessage)
                if (message.Data) {
                    if (message.Data.Items['soloDati']) {
                        var desc = "?$filter=((contains(tolower(descrizione)," + "'" + message.Data.Items['localita'].toLowerCase() + "')))";
                        _this.anagraficaService.getElenco('Comune', '', desc).then(function (ree) {
                            if (ree['items']) {
                                _this.formSoggetto.formEdit.instance.updateData('istatComune', ree['items'][0]['id']);
                                _this.formSoggetto.formEdit.instance.updateData('stato', 'IT');
                            }
                        });
                        _this.formSoggetto.formEdit.instance.updateData('ragioneSociale', message.Data.Items['ragione_Sociale']);
                        _this.formSoggetto.formEdit.instance.updateData('isoFiscale', 'IT');
                        _this.formSoggetto.formEdit.instance.updateData('siglaProvincia', message.Data.Items['prov']);
                        _this.formSoggetto.formEdit.instance.updateData('indirizzo', message.Data.Items['indirizzo']);
                        _this.formSoggetto.formEdit.instance.updateData('comune', message.Data.Items['localita']);
                        _this.formSoggetto.formEdit.instance.updateData('partitaIVA', message.Data.Items['tax']);
                        _this.formSoggetto.formEdit.instance.updateData('codiceFiscale', message.Data.Items['vat']);
                        _this.formSoggetto.formEdit.instance.updateData('pec', message.Data.Items['pec']);
                        _this.formSoggetto.formEdit.instance.updateData('cap', message.Data.Items['cap']);
                        _this.formSoggetto.formEdit.instance.updateData('civico', message.Data.Items['civico']);
                        _this.formSoggetto.formEdit.instance.updateData('stato', 'IT');
                    }
                    if (message.Data.Items['soloPec']) {
                        _this.formSoggetto.formEdit.instance.updateData('pec', message.Data.Items['pec']);
                    }
                }
            }
            else if (message.destComponent == 'AnaSoggetto' && message.traceMessage == 'chiudiInfoImpresa') {
                _this._overlaySidePanelService.close();
            }
        });
    };
    NicaMaster.prototype.gridEvent = function (e) {
        var _this = this;
        // console.log('stampo event',e)
        if (e.name == "onInitNewRow") {
            this.onAllEvent.emit(e);
        }
        if (e.name == "onInitilized") {
            this.onAllEvent.emit(e);
        }
        if (e.name == "masterDetailInitilized") {
            this.onAllEvent.emit(e);
        }
        if (e.name == "masterDetailContentReady" || e.componentName === "dettaglio1") {
            console.log('stampo event', e);
            //e.masterThis.griglia.instance.columnOption('tipoAttivita', 'visible', false);
            var items = e && e.component && e.component.getDataSource().items();
            if (items) {
                var newData = items.forEach(function (itm, i) {
                    if (typeof itm.items != 'undefined') {
                        itm.items.map(function (ppp, c) {
                            var tipoAttivita = [];
                            if (itm.idSedeRentri !== null) {
                                tipoAttivita.push({
                                    class: 'rentri-bg me-1',
                                    value: 'R'
                                });
                            }
                            if (ppp.isProduttore) {
                                tipoAttivita.push({
                                    class: 'produttore-bg me-1',
                                    value: 'P'
                                });
                            }
                            if (ppp.isTrasportatore) {
                                tipoAttivita.push({
                                    class: 'trasportatore-bg me-1',
                                    value: 'T'
                                });
                            }
                            if (ppp.isSmaltitore) {
                                tipoAttivita.push({
                                    class: 'destinatario-bg me-1',
                                    value: 'D'
                                });
                            }
                            if (ppp.isIntermediario) {
                                tipoAttivita.push({
                                    class: 'intermediario-bg ',
                                    value: 'I'
                                });
                            }
                            ppp.tipoAttivita = tipoAttivita;
                        });
                    }
                    else {
                        var tipoAttivita = [];
                        if (itm.idSedeRentri !== null) {
                            tipoAttivita.push({
                                class: 'rentri-bg me-1',
                                value: 'R'
                            });
                        }
                        if (itm.isProduttore) {
                            tipoAttivita.push({
                                class: 'produttore-bg me-1',
                                value: 'P'
                            });
                        }
                        if (itm.isTrasportatore) {
                            tipoAttivita.push({
                                class: 'trasportatore-bg me-1',
                                value: 'T'
                            });
                        }
                        if (itm.isSmaltitore) {
                            tipoAttivita.push({
                                class: 'destinatario-bg me-1',
                                value: 'D'
                            });
                        }
                        if (itm.isIntermediario) {
                            tipoAttivita.push({
                                class: 'intermediario-bg ',
                                value: 'I'
                            });
                        }
                        itm.tipoAttivita = tipoAttivita;
                    }
                });
            }
            // e.component.customizeColumns = (col) => {
            //   ////console.log('customizeColumns', col)
            // };
            /* isIntermediario
            isProduttore
            isSmaltitore
            isTrasportatore */
            /* if(e.data.isProduttore){
              e.component.set(e.rowIndex, 'tipoAttivita', 'Produttore');
            } */
            //}
        }
        if (e.name == "masterDetailSelection") {
            e.event.stopPropagation();
            e.event.preventDefault();
            this.onAllEvent.emit(e);
        }
        // if (e.name == "onContentReady" && e.componentName == 'sede') {
        //   //e.masterThis.griglia.instance.columnOption('tipoAttivita', 'visible', false);
        //   let items = e.component.getDataSource().items();
        //   let newData = items.forEach((itm, i) => {
        //     if (itm.items) {
        //       itm.items.map((ppp, c) => {
        //         let tipoAttivita = []
        //         if (itm.idSedeRentri !== null) {
        //         tipoAttivita.push({
        //           class: 'rentri-bg me-1',
        //           value: 'R'
        //         })
        //       }
        //         if (ppp.isProduttore) {
        //           tipoAttivita.push(
        //             {
        //               class: 'produttore-bg me-1',
        //               value: 'P'
        //             }
        //           )
        //         }
        //         if (ppp.isTrasportatore) {
        //           tipoAttivita.push(
        //             {
        //               class: 'trasportatore-bg me-1',
        //               value: 'T'
        //             }
        //           )
        //         }
        //         if (ppp.isSmaltitore) {
        //           tipoAttivita.push(
        //             {
        //               class: 'destinatario-bg me-1',
        //               value: 'D'
        //             }
        //           )
        //         }
        //         if (ppp.isIntermediario) {
        //           tipoAttivita.push({
        //             class: 'intermediario-bg ',
        //             value: 'I'
        //           })
        //         }
        //         ppp.tipoAttivita = tipoAttivita
        //       })
        //     } else {
        //       let tipoAttivita = [];
        //       if (itm.idSedeRentri !== null) {
        //         tipoAttivita.push({
        //           class: 'rentri-bg me-1',
        //           value: 'R'
        //         })
        //       }
        //       if (itm.isProduttore) {
        //         tipoAttivita.push(
        //           {
        //             class: 'produttore-bg me-1',
        //             value: 'P'
        //           }
        //         )
        //       }
        //       if (itm.isTrasportatore) {
        //         tipoAttivita.push(
        //           {
        //             class: 'trasportatore-bg me-1',
        //             value: 'T'
        //           }
        //         )
        //       }
        //       if (itm.isSmaltitore) {
        //         tipoAttivita.push(
        //           {
        //             class: 'destinatario-bg me-1',
        //             value: 'D'
        //           }
        //         )
        //       }
        //       if (itm.isIntermediario) {
        //         tipoAttivita.push({
        //           class: 'intermediario-bg ',
        //           value: 'I'
        //         })
        //       }
        //       itm.tipoAttivita = tipoAttivita
        //     }
        //   });
        // }
        if (e.name === "onCellPrepared" && e.componentName === 'sede') {
            if (e.dataField === 'tipoAttivita') {
                var tipoAttivita = [];
                if (e.data) {
                    if (e.data.idSedeRentri !== null) {
                        tipoAttivita.push({
                            class: 'badge rentri-bg me-1',
                            value: 'R'
                        });
                    }
                    if (e.data.isProduttore == 1) {
                        tipoAttivita.push({
                            class: 'badge produttore-bg me-1',
                            value: 'P',
                            hint: 'Produttore'
                        });
                    }
                    if (e.data.isTrasportatore == 1) {
                        tipoAttivita.push({
                            class: 'badge trasportatore-bg me-1',
                            value: 'T',
                            hint: 'Trasportatore'
                        });
                    }
                    if (e.data.isSmaltitore == 1) {
                        tipoAttivita.push({
                            class: 'badge destinatario-bg me-1',
                            value: 'S',
                            hint: 'Smaltitore'
                        });
                    }
                    if (e.data.isIntermediario == 1) {
                        tipoAttivita.push({
                            class: 'badge intermediario-bg me-1',
                            value: 'I',
                            hint: 'Intermediario'
                        });
                    }
                    e.cellElement.innerHTML = tipoAttivita.map(function (item) { return "<span class=\"" + item.class + "\" title=\"" + (item.hint || '') + "\">" + item.value + "</span>"; }).join('');
                }
            }
        }
        if (e.name == "onEditorPrepared") {
            e.cancel = true;
            var data_6 = e.data;
            /**Gestisco i queryurl Filtri in Base al Edit**/
            if (this.anagraficaDati[0]['configuration']['queryFilter']) {
                var arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter']; // prendo i campi di riferimento da passare alla Form dalla configurazione
                var newItem_8;
                arrayIdRif.forEach(function (idTab) {
                    var _a;
                    if (typeof data_6[idTab['value']] != 'undefined') {
                        newItem_8 = __assign({}, _this.filterID, (_a = {}, _a[idTab['key']] = data_6[idTab['value']], _a));
                        _this.filterID = newItem_8;
                    }
                });
            }
            this.filterID['isEdit'] = true;
            e.descEvent = 'Modifica';
            this.refreshPage(e.data, 'Modifica', this.SubjectCall, 'form');
        }
        if (e.name == "onInitNewRow") {
            ////console.log('onInitNewRow', this.filterID)
            e.cancel = true;
            e.descEvent = 'Inserisci';
            this.filterID['isEdit'] = false;
            //this.formSoggetto.formRefresh()
            this.refreshPage('', e.descEvent, this.SubjectCall, 'form');
        }
        if (e.name == 'onSelectionChanged') {
            e.event.stopPropagation();
            e.event.preventDefault();
            this.onAllEvent.emit(e);
        }
        if (e.name == 'masterDetailInsert') {
            e.cancel = true;
            e.cancellaRefresh = false;
            e.event.stopPropagation();
            e.event.preventDefault();
            this.onAllEvent.emit(e);
            if (e.cancellaRefresh) {
                return;
            }
            e.descEvent = 'Inserisci';
            this.filterID['isEdit'] = false;
            var data_7 = e.data;
            var detailRif = e.detailRif[0];
            var detailDataForm = this.templateService.getService(this.SubjectCall);
            if (detailDataForm[0]['configuration']['queryFilter']) {
                var arrayIdRif = detailDataForm[0]['configuration']['queryFilter']; // prendo i campi di riferimento da passare alla Form dalla configurazione
                var newItem_9;
                arrayIdRif.forEach(function (idTab) {
                    var _a;
                    if (typeof data_7[idTab['value']] != 'undefined') {
                        newItem_9 = __assign({}, _this.filterID, (_a = {}, _a[idTab['key']] = data_7[idTab['value']], _a));
                        _this.filterID = newItem_9;
                    }
                });
            }
            this.filterID['isEdit'] = false;
            var pathUrl = 'main/' + detailRif.path;
            //console.log('masterDetailInsert-->', e);
            this.refreshPage('', '', detailRif['service'], 'form', '', detailRif.componenName, pathUrl);
            //this.refreshPage('', e.descEvent, this.SubjectCall, 'form')
        }
        if (e.name == 'masterDetailEdit') {
            e.cancel = true;
            this.onAllEvent.emit(e);
            if (e.cancellaRefresh) {
                return;
            }
            //console.log('masterDetailEdit', e)
            // //console.log('masterThis', e.masterThis.griglia.instance.getSelectedRowKeys())
            var data_8 = e.data;
            /**Gestisco i queryurl Filtri in Base al Edit**/
            var detailDataForm = this.templateService.getService(e.detailRif[0]['service']);
            if (detailDataForm[0]['configuration']['queryFilter']) {
                var arrayIdRif = detailDataForm[0]['configuration']['queryFilter']; // prendo i campi di riferimento da passare alla Form dalla configurazione
                var newItem_10;
                arrayIdRif.forEach(function (idTab) {
                    var _a;
                    if (typeof data_8[idTab['value']] != 'undefined') {
                        newItem_10 = __assign({}, _this.filterID, (_a = {}, _a[idTab['key']] = data_8[idTab['value']], _a));
                        _this.filterID = newItem_10;
                    }
                });
            }
            this.filterID['isEdit'] = true;
            var detailRif = e.detailRif[0];
            var pathUrl = 'main/' + detailRif.path;
            this.refreshPage(data_8, '', e.detailRif[0]['service'], 'form', '', detailRif.componenName, pathUrl);
            return;
            var queryFilter = JSON.stringify(this.filterID);
            var navigationParams = {
                api: detailDataForm[0]['configuration']['api'],
                service: detailDataForm[0]['configuration']['service'],
                masterKey: detailDataForm[0]['configuration']['masterKey'],
                filter: queryFilter,
                queryFilter: JSON.stringify(this.filterID),
                descEvent: '',
                templateView: 'form',
                titoloDaPortare: '',
                data: data_8,
                id: data_8.id,
                prevUrl: this.previusUrl,
                currentTabId: this.currentTabId,
                currentTabName: this.currentTabName,
                componentName: detailRif.componentName
            };
            this.router.navigate(['main/' + detailRif.path], {
                queryParams: navigationParams,
                skipLocationChange: false,
                replaceUrl: true
            }).then(function (res) {
            });
        }
        if (e.name == 'onRowExpanding') {
            //e.cancel = true;
            this.onAllEvent.emit(e);
        }
    };
    NicaMaster.prototype.updateFilterGrid = function (queryString, griglia) {
        this.filterGrid = this.filterGrid.split('&')[0] + '&' + queryString;
        //localStorage.setItem('Filtri', JSON.stringify({ queryString }));
        if (typeof this.nicaAnagrafica != 'undefined') {
            this.nicaAnagrafica.refresh();
            return;
        }
        griglia.refresh();
    };
    NicaMaster.prototype.updateFilterIconColors = function (hasQuery) {
        var color = hasQuery ? '#edcd5f' : '#023957';
        Array.from(document.getElementsByClassName('dx-icon export icon-filter')).forEach(function (icon) { return icon.style.color = color; });
    };
    NicaMaster.prototype.refreshPage = function (data, descEvent, service, template, buttonParams, component, pathUrl) {
        var _this = this;
        if (descEvent === void 0) { descEvent = ''; }
        if (typeof this.itemData != 'undefined') {
            //template = template == 'form'?'grid': template
            this.refreshData(data, descEvent = '', service, template, component);
            return;
        }
        var titoloDaPortare;
        var id;
        if (typeof data != 'undefined' || data != '') {
            id = data['id'];
            //this.filterID['isEdit'] = true
        }
        var filter = '';
        var dataToSend = JSON.stringify(data);
        if (typeof this.filterID == 'object') {
            filter = JSON.stringify(this.filterID);
        }
        //let filterId = {...this.filterID};
        var cUrl = '';
        if (pathUrl) {
            cUrl = pathUrl;
        }
        else {
            cUrl = this.router.url.split('?')[0];
        }
        var api = this.apiset;
        var componentName = component ? component : this.params.componentName;
        if (buttonParams) {
            cUrl = buttonParams.path;
            api = buttonParams.api;
            componentName = buttonParams.componentName;
        }
        var navigationParams = {
            id: id,
            api: api,
            service: service,
            masterKey: 'id',
            filter: filter,
            descEvent: descEvent,
            templateView: template,
            titoloDaPortare: titoloDaPortare,
            /* data: dataToSend, */
            prevUrl: this.previusUrl,
            currentTabId: this.currentTabId,
            currentTabName: this.currentTabName,
            componentName: componentName
        };
        this.router.navigate(['/'], {
            skipLocationChange: false,
            replaceUrl: true
        }).then(function () {
            // Forzo a naviagare verso questa url per aggiornare i dati. 
            //sono costretto a ricaricare in maniera forzata il componente in attesa di idee
            var navigationExtras = {
                queryParams: navigationParams,
                skipLocationChange: false,
                replaceUrl: false
            };
            _this.router.navigate([cUrl], navigationExtras);
            /* const queryParams = navigationParams
      
      
            let nav = {
              title: this.breadcrumbCaption,
              cRouter: cUrl,
              params: queryParams,
      
      
            }
      
            this.userComponentService.setComponentNavigation(nav) */
            /* if(service=='soggetto' && template=='grid'){
              this.userComponentService.removeAllItemComponentFromID('soggetto',this.currentTabId)
            } */
        });
    };
    NicaMaster.prototype.refreshData = function (data, descEvent, service, template, component) {
        var _this = this;
        if (descEvent === void 0) { descEvent = ''; }
        var titoloDaPortare;
        var id;
        if (typeof data != 'undefined' || data != '') {
            id = data['id'];
        }
        var dataToSend = JSON.stringify(data);
        var filter = JSON.stringify(this.filterID);
        var cUrl = this.router.url.split('?')[0];
        var api = this.apiset;
        var componentName = component ? component : this.currentTabName;
        var currentPopupsSet = this.userComponentService.currentPopupsSet;
        var index = currentPopupsSet.findIndex(function (rrrr) { return rrrr.id == _this.currentTabId && rrrr.componentName == componentName; });
        var guid = Math.random().toString().replace("0.", "");
        if (index >= 0) {
            guid = this.currentTabId;
        }
        var navigationParams = [{
                id: id,
                api: api,
                service: service,
                masterKey: 'id',
                filter: filter,
                descEvent: descEvent,
                templateView: template,
                titoloDaPortare: titoloDaPortare,
                data: dataToSend,
                prevUrl: this.previusUrl,
                currentTabId: guid,
                currentTabName: componentName,
                componentName: componentName,
            }];
        if (index >= 0) {
            guid = this.currentTabId;
            //this.resettaVariabiliGlobali()
            //this.setGlobalVariableFromParams(navigationParams[0]);
        }
        this.userComponentService.setNewPopUp(guid, componentName, navigationParams, null, null, null, false, false, null, 'bottom');
        this.userComponentService.removeNavigationComponent(service, componentName);
    };
    NicaMaster.prototype.resettaVariabiliGlobali = function () {
        var _this = this;
        // Ottieni tutte le proprietà dell'istanza del componente
        var props = Object.getOwnPropertyNames(this);
        // Itera attraverso le proprietà e azzerale se non sono metodi o proprietà interne di Angular
        props.forEach(function (prop) {
            if (typeof _this[prop] !== 'function' && !prop.startsWith('_') && prop !== 'constructor') {
                _this[prop] = null;
            }
        });
    };
    NicaMaster.prototype.buildDataToTake = function (dataForm, dataTake) {
        var values = this.filterID;
        dataTake.forEach(function (element) {
            var _a;
            var keyEle = element['keyResult'];
            var val = element['valueToTake'];
            if (typeof dataForm[element['valueToTake']] != 'undefined') {
                val = dataForm[element['valueToTake']];
            }
            values = __assign({}, values, (_a = {}, _a[keyEle] = val, _a));
        });
        this.filterID = values;
    };
    NicaMaster.prototype.addDataToFilterID = function (dataForm, queryFilter) {
        var values = this.filterID;
        queryFilter.forEach(function (element) {
            var _a;
            var keyEle = element['key'];
            var val = element['value'];
            if (typeof dataForm[element['value']] != 'undefined') {
                val = dataForm[element['value']];
            }
            values = __assign({}, values, (_a = {}, _a[keyEle] = val, _a));
        });
        this.filterID = values;
    };
    NicaMaster.prototype.openFunction = function (infoData) {
        var _this = this;
        /*
            {
        name: 'Documenti',
        icon: 'glyphicon icon-documenti-form',
        displayMode: 'in-line',
        service: 'allegati',
        api: 'Allegati',
        path: '',
        templateComponent: '',
        componentName: 'AllegatiComponent',
        costantValue: [
          { key: 'nomeTabella', value: 'soggetti' }
        ],
        hint: 'Lista allegati',
        event: '1',
        location: 'top',
        visible: true,
        disabled: false,
        wPopUp: "1000",
        hPopUp: "700"
      },
        */
        //////console.log("EM VALUE I ANA SOGGETTO ",infoData)
        if (!infoData[0].value) {
            alert('Funzione non disponibile', 'Attenzione!');
            return;
        }
        ////////console.log(em)
        var factories = Array.from(this._componentFactoryResolver['_factories'].keys());
        var factoryClass = factories.find(function (x) { return x.name === infoData[0].infoButton.componentName; });
        this._overlaySidePanelService.setTitle(infoData[0].infoButton.name);
        this._overlaySidePanelService.setContent(factoryClass);
        this._overlaySideFormService.setToolBarVisible(false);
        this._overlaySideFormService.setPopupWidth((infoData[0].infoButton.wPopUp) ? infoData[0].infoButton.wPopUp : 800);
        this._overlaySideFormService.setPopupHeight((infoData[0].infoButton.hPopUp) ? infoData[0].infoButton.hPopUp : 500);
        ////console.log("EM VALUE I ANA SOGGETTO ",infoData[0])
        this._overlaySidePanelService.sendDataToComponent(infoData);
        this._overlaySidePanelService.show();
        setTimeout(function () {
            //this._overlaySideFormService._hrefComponent.instance.class = 'soggetto-form';
            _this._overlaySideFormService._hrefComponent.instance.emittedData.subscribe(function (ress) {
                ////console.log('emittedData', ress);
                ////////console.logmessage)
                if (ress) {
                    if (ress.data) {
                        var emittedData = ress.data;
                        if (emittedData[_this.masterKey]) {
                            delete emittedData[_this.masterKey];
                        }
                        for (var x in emittedData) {
                            if (_this.formSoggetto.checkDataField(x)) {
                                _this.formSoggetto.formRefreshInputData(x, emittedData[x]);
                                _this._overlaySideFormService.close();
                                notify({
                                    message: 'Operazione completata',
                                    height: 45,
                                    width: 150,
                                    position: 'center center'
                                }, 'success', 3500);
                            }
                        }
                        //emittedData
                    }
                }
            });
        }, 300);
    };
    NicaMaster.prototype.dateParse = function (dateTime) {
        var dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
        var isMatch = dateType.test(dateTime);
        if (isMatch) {
            var date = new Date(dateTime);
            var month = ("0" + (date.getMonth() + 1)).slice(-2);
            month + 1;
            var day = date.getDate().toString().padStart(2, '0');
            return date.getFullYear() + '-' + month + '-' + day;
        }
        else {
            return dateTime;
        }
    };
    NicaMaster.prototype.dateParseIT = function (dateTime) {
        var dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
        var isMatch = dateType.test(dateTime);
        if (isMatch) {
            var date = new Date(dateTime);
            var month = ("0" + (date.getMonth() + 1)).slice(-2);
            month + 1;
            var day = date.getDate().toString().padStart(2, '0');
            return day + '/' + month + '/' + date.getFullYear();
        }
        else {
            return dateTime;
        }
    };
    NicaMaster.prototype.formatDate = function (dateString, type) {
        if (type === void 0) { type = 'EN'; }
        var regExpISO = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
        var regExpIT = /(\d{1,2})([\/-])(\d{1,2})\2(\d{4})/;
        var isMatchISO = dateString.match(regExpISO);
        var isMatchIT = dateString.match(regExpIT);
        //Se nessuno dei 2 formati è valido
        if (!isMatchISO && !isMatchIT) {
            return undefined;
        }
        if (isMatchIT) {
            if (dateString.includes('-'))
                dateString = dateString.split('-')[2] + "-" + dateString.split('-')[1] + "-" + dateString.split('-')[0];
            else if (dateString.includes('/'))
                dateString = dateString.split('/')[2] + "-" + dateString.split('/')[1] + "-" + dateString.split('/')[0];
        }
        var date = new Date(dateString);
        // Formatta la data come necessario
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, '0'); // Mese è 0-based
        var day = date.getDate().toString().padStart(2, '0');
        if (type == 'EN') {
            return year + "-" + month + "-" + day;
        }
        if (type == 'it') {
            return day + "-" + month + "-" + year + " ";
        }
    };
    NicaMaster.prototype.buildFilterList = function (formData, isOr) {
        if (isOr === void 0) { isOr = false; }
        var myqueryStrigOdata = [];
        var queryStrigOdata = '';
        // for(let xin in formData){
        //   if(xin){
        //   }
        // }
        for (var xin in formData) {
            var type = this.getTypeOfField(formData[xin]);
            var value = formData[xin];
            var dataField = xin;
            if (typeof type != 'undefined') {
                if (this.builderOdataSearchString(dataField, type, value)) {
                    myqueryStrigOdata.push(this.builderOdataSearchString(dataField, type, value));
                }
            }
        }
        if (myqueryStrigOdata.length > 0) {
            if (!isOr) {
                queryStrigOdata = myqueryStrigOdata.join(' and  ');
            }
            else {
                queryStrigOdata = myqueryStrigOdata.join(' or  ');
            }
        }
        return queryStrigOdata;
    };
    NicaMaster.prototype.buildFilterList2 = function (formData, isOr) {
        if (isOr === void 0) { isOr = false; }
        var myqueryStrigOdataBooleanObject = [];
        var myqueryStrigOdataOthers = [];
        var queryStrigOdata = '';
        for (var xin in formData) {
            var type = this.getTypeOfField(formData[xin]);
            var value = formData[xin];
            var dataField = xin;
            if (typeof type != 'undefined') {
                var filterString = this.builderOdataSearchString(dataField, type, value);
                if (filterString) {
                    if (type.toLowerCase() === 'boolean' || type.toLowerCase() === 'object') {
                        myqueryStrigOdataBooleanObject.push(filterString);
                    }
                    else {
                        myqueryStrigOdataOthers.push(filterString);
                    }
                }
            }
        }
        if (myqueryStrigOdataBooleanObject.length > 0) {
            var booleanObjectQuery = myqueryStrigOdataBooleanObject.join(' or ');
            queryStrigOdata += booleanObjectQuery;
        }
        if (myqueryStrigOdataOthers.length > 0) {
            var othersQuery = myqueryStrigOdataOthers.join(' and ');
            if (queryStrigOdata) {
                queryStrigOdata += ' and ' + othersQuery;
            }
            else {
                queryStrigOdata = othersQuery;
            }
        }
        return queryStrigOdata;
    };
    NicaMaster.prototype.builderOdataSearchString = function (dataField, tipoCampo, value) {
        if (!value) {
            return null;
        }
        //console.warn(searchType);
        switch (tipoCampo.toLowerCase()) {
            case 'text':
                return "(contains(tolower(" + dataField + "),'" + value.toLowerCase() + "'))";
            case 'string':
                return "(contains(tolower(" + dataField + "),'" + value.toLowerCase() + "'))";
            case 'number':
                var strToNumber = Number(value);
                if (!isNaN(strToNumber))
                    return "(" + dataField + " eq " + strToNumber + ")";
            case 'date':
            case 'dateTime':
                {
                    var dataFormattata = this.formatDate(value);
                    if (typeof dataFormattata !== 'undefined')
                        return "(" + dataField + " eq " + dataFormattata + ")";
                }
            case 'boolean':
                return "(" + dataField + " eq " + value + ")";
            case 'array':
                var stringQueryA_1 = [];
                value.forEach(function (val) {
                    if (typeof val === 'number')
                        stringQueryA_1.push("(" + dataField + " eq " + val + ") ");
                    if (typeof val === 'string')
                        stringQueryA_1.push("(contains(tolower(" + dataField + "),'" + val.toLowerCase() + "'))");
                });
                return stringQueryA_1.join(' or ');
            case 'object':
                var stringQuery = [];
                for (var c in value) {
                    stringQuery.push("(" + c + " eq " + value[c] + ") ");
                }
                return stringQuery.join(' or ');
            default:
            /* if(typeof searchType == 'undefined' || searchType == 'contains')
              return `(contains(tolower(${dataField}),'${this.searchText.toLowerCase()}'))`;
            else
              return `(startswith(tolower(${dataField}),'${this.searchText.toLowerCase()}'))`; */
        }
    };
    NicaMaster.prototype.getTypeOfField = function (value) {
        if (value === null) {
            return 'null';
        }
        if (value === undefined) {
            return 'undefined';
        }
        if (Array.isArray(value)) {
            return 'array';
        }
        if (value instanceof Date) {
            return 'date';
        }
        if (typeof value === 'number') {
            return 'number';
        }
        if (typeof value === 'string') {
            return 'string';
        }
        if (typeof value === 'boolean') {
            return 'boolean';
        }
        if (typeof value === 'object') {
            return 'object';
        }
        return 'unknown';
    };
    NicaMaster.prototype.getPrevItemComponentNavigation = function (id, currentTabId) {
        if (this.cronNavigation.length > 0) {
            var currentNav = this.userComponentService.getCurrentRouterNav(currentTabId);
            var currentItemIndex = currentNav[0].data.findIndex(function (items) { return items.id == id; }) - 1;
            //console.log('getPrevItemComponentNavigation', currentItemIndex)
            if (currentItemIndex >= 0) {
                return currentNav[0].data[currentItemIndex];
            }
            else {
                var cLast = currentNav[0].data.length - 1;
                var prev = cLast - 1;
                if (prev >= 0)
                    return currentNav[0].data[prev];
            }
            //currentNav[0].data.splice(-1);
            //this.navComponent.splice(-1);
            //this._componentRouter.next(currentNav)
        }
    };
    NicaMaster.prototype.returnPrevUrl = function () {
        var _this = this;
        var copyF = this.filterID;
        if (typeof this.idBreadcrumbGroup != 'undefined' && this.SubjectCall != this.idBreadcrumbGroup) {
            this.returnUrlBy();
            return;
        }
        else if (copyF['movimento']) {
            var e = { event: 5 };
            this.buttonEmitted(e);
            return;
        }
        var prevItemNavigation = this.getPrevItemComponentNavigation(this.SubjectCall, this.currentTabId);
        if (typeof prevItemNavigation == 'undefined') {
            prevItemNavigation = this.getPrevItemComponentNavigation(this.idBreadcrumbGroup, this.currentTabId);
        }
        setTimeout(function () {
            _this.router.navigate(['/'], {
                skipLocationChange: true,
                replaceUrl: true
            }).then(function () {
                // Forzo a naviagare verso questa url per aggiornare i dati. 
                //è un pezzoto ma NicaAnagrafica non si aggiorna,
                //sono costretto a ricaricare in maniera forzata il componente in attesa di idee
                var navigationExtras = {
                    queryParams: prevItemNavigation['params'],
                    skipLocationChange: true,
                    replaceUrl: true
                };
                _this.router.navigate([prevItemNavigation['cRouter']], navigationExtras);
                _this.userComponentService.removeLastItemComponentNavigation(_this.params.currentTabId);
                //this.loader.hide()
            });
        }, 200);
        return;
    };
    NicaMaster.prototype.returnUrlBy = function (id) {
        var _this = this;
        this.userComponentService.componentRouter.forEach(function (res) {
            if (Array.isArray(res) && res.length > 0) {
                _this.cronNavigation = res.filter(function (res) { return res.idTab == _this.currentTabId; });
            }
        });
        if (this.cronNavigation.length > 0) {
            var navigations = this.cronNavigation.filter(function (res) { return res.idTab == _this.currentTabId; });
            var navigation = navigations[0].data;
            var checkItemIdex = navigation.findIndex(function (n) { return n.id == _this.idBreadcrumbGroup; });
            if (checkItemIdex >= 0) {
                var nav = navigation[checkItemIdex];
                var cUrl_2 = nav.cRouter;
                var navigationParams_2 = nav.params;
                this.router.navigate(['/'], {
                    skipLocationChange: false,
                    replaceUrl: true
                }).then(function () {
                    // Forzo a naviagare verso questa url per aggiornare i dati. 
                    //sono costretto a ricaricare in maniera forzata il componente in attesa di idee
                    var navigationExtras = {
                        queryParams: navigationParams_2,
                        skipLocationChange: false,
                        replaceUrl: true
                    };
                    _this.router.navigate([cUrl_2], navigationExtras);
                });
            }
        }
        return;
    };
    NicaMaster.prototype.showingPopUp = function (e) {
        e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
        e.component.content().classList.add("formEditPopupContet"); //add class to content
        e.component.content().classList.add("bg-grey"); //add class to content
        e.component.content().classList.add("soggetto-form"); //add class to content
    };
    NicaMaster.prototype.openComponentInPopUP = function (componentName, data, InstanceDatadata, width, popupTitle, showCaptionFooter, showCaptionHeader, position, help) {
        if (data === void 0) { data = []; }
        if (width === void 0) { width = ''; }
        if (showCaptionFooter === void 0) { showCaptionFooter = true; }
        if (showCaptionHeader === void 0) { showCaptionHeader = true; }
        if (position === void 0) { position = 'center'; }
        if (help === void 0) { help = '-'; }
        var guid = Math.random().toString().replace("0.", "");
        if (data.length > 0) {
            data[0].currentTabId = guid;
        }
        //InstanceDatadata['guid']=guid
        this.userComponentService.setNewPopUp(guid, componentName, data, width, null, InstanceDatadata, showCaptionFooter, showCaptionHeader, popupTitle, position, help);
        return guid;
    };
    NicaMaster.prototype.closeComponentInPopUP = function () {
        this.userComponentService.closeOverlayForm();
    };
    NicaMaster.prototype.queryStringByService = function (service, rowData, key) {
        var anagraficaConfig = this.templateService.getService(service)[0]['configuration'];
        var filterKey = anagraficaConfig[key];
        var returnFilter = filterKey;
        if (returnFilter.includes('$')) {
            for (var x in rowData) {
                if (returnFilter.includes(x)) {
                    var regex = new RegExp('\\$' + x + '\\b', 'g');
                    var matchFilter = returnFilter.match(regex);
                    if (matchFilter) {
                        if (typeof rowData[x] !== 'undefined') {
                            returnFilter = returnFilter.replace(regex, rowData[x]);
                        }
                    }
                    else {
                        if (typeof rowData[x] !== 'undefined') {
                            var pattern = /\?id=\$/;
                            var reee = pattern.test(returnFilter);
                            if (reee) {
                                var espressioneRegolare = /\$/;
                                var nuovaStringa = returnFilter.replace(espressioneRegolare, rowData[x]);
                                returnFilter = nuovaStringa;
                            }
                        }
                    }
                }
            }
            // Nuova gestione per filterKey che contiene solo "$" o "/$"
            if (filterKey === "/$" || filterKey === "$") {
                if (rowData['id']) {
                    returnFilter = returnFilter.replace('$', rowData['id']);
                }
            }
        }
        if (filterKey !== returnFilter) {
            return returnFilter;
        }
        else {
            return null;
        }
    };
    NicaMaster.prototype.resettaFiltroApplicato = function (key) {
        var _this = this;
        //this.loader.show()
        if (key) {
            var filtriOBJ = JSON.parse(sessionStorage.getItem('Filtri'));
            delete filtriOBJ[key];
            sessionStorage.setItem('Filtri', JSON.stringify(filtriOBJ));
        }
        setTimeout(function () {
            for (var i = 0; i < document.getElementsByClassName('dx-icon export icon-filter').length; i++) {
                if (document.getElementsByClassName('dx-icon export icon-filter').item(i).parentElement.parentElement.id == 'bottoneFiltroToolbar') {
                    document.getElementsByClassName('dx-icon export icon-filter').item(i).style.color = '#023957';
                    break;
                }
            }
        }, 500);
        var anagraficaFilter = this.anagraficaDati.filter(function (r) { return r.configuration; });
        this.impostaFiltroGriglia(null, anagraficaFilter);
        /* if (this.filterGrid.split('?').length > 1){
          
         
            let regexFilter =  /\$filter=\(.*?\)&/;
            //let regexFilter2 = /\$filter=(.*)/ ;
            let checkQuery = this.filterGrid.match(regexFilter);
            //let checkQuery2 = this.filterGrid.match(regexFilter2);
            if (checkQuery) {
              this.filterGrid =   this.filterGrid.replace(regexFilter, '');
              //this.filterGrid =   this.filterGrid.replace(regexFilter2, '');
            }
          
        } */
        setTimeout(function () {
            _this.nicaAnagrafica.refresh();
            //this.loader.hide()
        }, 500);
    };
    NicaMaster.prototype.checkAndRemoveDuplicates = function (arr, key) {
        var e_3, _a;
        var seenIds = new Set();
        var result = [];
        try {
            for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
                var item = arr_1_1.value;
                if (seenIds.has(item[key])) {
                    alert("Duplicato trovato: " + item[key], 'Attenzione!');
                    continue; // Salta questo elemento se è un duplicato
                }
                seenIds.add(item[key]);
                result.push(item);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return result;
    };
    NicaMaster.ctorParameters = function () { return [
        { type: ComponentService },
        { type: FormsTemplateService },
        { type: OverlaySideFormService },
        { type: OverlaySideFormService },
        { type: FormsTemplateService },
        { type: ComponentFactoryResolver },
        { type: ActivatedRoute },
        { type: Router },
        { type: NicaMenuService },
        { type: RentriService },
        { type: AnagraficaService },
        { type: ModelliStampaService },
        { type: NgxSpinnerService }
    ]; };
    __decorate([
        ViewChild('formSoggetto', { static: false }),
        __metadata("design:type", NicaFormComponent)
    ], NicaMaster.prototype, "formSoggetto", void 0);
    __decorate([
        ViewChild('formAnagrafica', { static: false }),
        __metadata("design:type", NewNicaFormComponent)
    ], NicaMaster.prototype, "formAnagrafica", void 0);
    __decorate([
        ViewChild('dynamicComponent', { static: false }),
        __metadata("design:type", NicaDynamicContentComponent)
    ], NicaMaster.prototype, "dynamicComponent", void 0);
    __decorate([
        ViewChild('nicaAnagrafica', { static: false }),
        __metadata("design:type", NicaAnagraficaComponent)
    ], NicaMaster.prototype, "nicaAnagrafica", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], NicaMaster.prototype, "itemData", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], NicaMaster.prototype, "InviaA", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], NicaMaster.prototype, "onAllEvent", void 0);
    __decorate([
        HostListener('window:keydown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], NicaMaster.prototype, "handleKeyDown", null);
    NicaMaster = __decorate([
        Component({
            selector: 'app-master-component',
            template: '',
            styles: [__importDefault(require("./nica-master.component.css")).default]
        }),
        __metadata("design:paramtypes", [ComponentService,
            FormsTemplateService,
            OverlaySideFormService,
            OverlaySideFormService,
            FormsTemplateService,
            ComponentFactoryResolver,
            ActivatedRoute,
            Router,
            NicaMenuService,
            RentriService,
            AnagraficaService,
            ModelliStampaService,
            NgxSpinnerService])
    ], NicaMaster);
    return NicaMaster;
}());
export { NicaMaster };
//# sourceMappingURL=nica-master.component.js.map